var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#160051"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6673 36C33.6673 36.5523 34.115 37 34.6673 37C35.2196 37 35.6673 36.5523 35.6673 36H33.6673ZM12.334 36C12.334 36.5523 12.7817 37 13.334 37C13.8863 37 14.334 36.5523 14.334 36H12.334ZM35.6673 36C35.6673 33.6898 34.1719 31.7497 32.0731 30.438C29.9603 29.1174 27.1036 28.3333 24.0007 28.3333V30.3333C26.7887 30.3333 29.2654 31.0416 31.0131 32.134C32.7749 33.2351 33.6673 34.6283 33.6673 36H35.6673ZM24.0007 28.3333C20.8977 28.3333 18.041 29.1174 15.9282 30.438C13.8294 31.7497 12.334 33.6898 12.334 36H14.334C14.334 34.6283 15.2264 33.2351 16.9882 32.134C18.7359 31.0416 21.2126 30.3333 24.0007 30.3333V28.3333ZM24.0007 24.3333C20.871 24.3333 18.334 21.7963 18.334 18.6667H16.334C16.334 22.9009 19.7665 26.3333 24.0007 26.3333V24.3333ZM18.334 18.6667C18.334 15.5371 20.871 13 24.0007 13V11C19.7665 11 16.334 14.4325 16.334 18.6667H18.334ZM24.0007 13C27.1303 13 29.6673 15.5371 29.6673 18.6667H31.6673C31.6673 14.4325 28.2348 11 24.0007 11V13ZM29.6673 18.6667C29.6673 21.7963 27.1303 24.3333 24.0007 24.3333V26.3333C28.2348 26.3333 31.6673 22.9009 31.6673 18.6667H29.6673Z",
    fill: "#F9FAFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.49f5cddabb473f99518a148303714a78.svg";
export { ForwardRef as ReactComponent };